import { type ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import type { Icon } from '@phosphor-icons/react';

import classNames from '@/utils/classnames';

const ITEM_BASE = 'flex h-8 items-center gap-2.5 rounded-lg px-2 text-xs no-underline transition-colors';
const ITEM_INACTIVE = 'text-fg-secondary hover:bg-surface-3 hover:text-fg';
const ITEM_ACTIVE = 'bg-surface-3 font-medium text-fg';

interface SidebarNavItemProps {
  to: string;
  icon: Icon;
  label: string;
  /** Match the path exactly (for index routes like /admin). */
  end?: boolean;
}

/** Route-driven sidebar nav row — shared so every sidebar's items look identical. */
export function SidebarNavItem({ to, icon: IconCmp, label, end }: SidebarNavItemProps) {
  return (
    <NavLink to={to} end={end} className="no-underline">
      {({ isActive }) => (
        <div className={classNames(ITEM_BASE, isActive ? ITEM_ACTIVE : ITEM_INACTIVE)}>
          <IconCmp size={16} weight={isActive ? 'fill' : 'regular'} className="shrink-0" />
          <span className="truncate">{label}</span>
        </div>
      )}
    </NavLink>
  );
}

/** Uppercase group label between nav sections. */
export function SidebarSectionLabel({ children }: { children: ReactNode }) {
  return <div className="px-2 pb-1 text-2xs font-semibold uppercase tracking-wider text-fg-muted">{children}</div>;
}
